module.exports = __webpack_public_path__ + "media/images/konintodoke/other_services/logo04-dba1c7855a7e2956a74a816b4eb85699.png";